import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import { SuketBaseWithRelationship } from "@/types/suket_tato-tindik";
import CommonFormulir, { EnFormulirCategory } from "@/services/CommonFormulir";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "formulir-asesmen-okupasi-terapi"
})
class FormulirAsesmenOkupasiTerapi extends VuexModule {
  formulir: SuketBaseWithRelationship = null;
  loading = false;

  http: CommonFormulir = new CommonFormulir(
    EnFormulirCategory.AsesmenOkupasiTerapi
  );

  @Mutation
  SET_DATA(formulir: SuketBaseWithRelationship) {
    this.formulir = formulir;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async getByRegister(noReg): Promise<void> {
    this.SET_LOADING(true);

    const formArray = await this.http.getByRegister(noReg).finally(() => {
      this.context.commit("SET_LOADING", false);
    });

    this.SET_DATA(formArray.data.length ? formArray.data[0] : null);
  }
}

export default getModule(FormulirAsesmenOkupasiTerapi);
